module.exports = __webpack_public_path__ + "img/icon-v.df2bd026.svg";